import axios from 'axios';
// (可選) 如果您使用 Element Plus，可以引入 ElMessage 來做錯誤提示
import { ElMessage } from 'element-plus';

// 1. 創建一個新的 Axios 實例
const service = axios.create({
  // 從環境變數讀取 API 的 base_url，這是一個最佳實踐
  // Vite 環境變數：import.meta.env.VITE_API_BASE_URL
  // Webpack 環境變數：process.env.VUE_APP_BASE_API
  baseURL: "https://gamelys.top/api" || '/api', 
  timeout: 10000, // 請求超時時間
});


// 2. 請求攔截器 (Request Interceptor)
service.interceptors.request.use(
  (config) => {
    // 在發送請求前做些什麼，例如加上 token
    const token = localStorage.getItem('authToken'); // 從本地存儲獲取 token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // 您也可以在這裡添加全局的 loading 效果
    return config;
  },
  (error) => {
    // 對請求錯誤做些什麼
    console.error('Request Interceptor Error:', error);
    return Promise.reject(error);
  }
);


// 3. 響應攔截器 (Response Interceptor)
service.interceptors.response.use(
  /**
   * 如果您想獲取 http 資訊，如 headers 或 status
   * 請 return response => response
  */
  (response) => {
    // 對響應數據做點什麼
    // 通常後端會返回 { code: 200, message: '...', data: ... } 的格式
    const res = response.data;

    // 如果 code 不是成功狀態碼 (例如 200)，就判斷為錯誤。
    if (res.code !== 200) {
      ElMessage({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
      
      // 例如：50008: 無效的 token; 50012: 其他客戶端登入; 50014: Token 過期;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // 可以做重新登入的操作
        // 例如：MessageBox.confirm(...)
      }

      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      // 如果成功，直接返回後端的 data 部分，讓元件內調用時更方便
      return res.data;
    }
  },
  (error) => {
    // 對響應錯誤做點什麼
    console.error('Response Interceptor Error:', error);
    ElMessage({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

// 4. 導出 Axios 實例
export default service;